// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCompanyProfessionRequestModel from '../../model/get-company-profession-request-model';
import GetCompanyProfessionRequestDTO from '../dto/get-company-profession-request-dto';
import dtoSchema from '../schemas/get-company-profession-request-schema';

export default abstract class GetCompanyProfessionRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCompanyProfessionRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.eventIdentifier = data.eventIdentifier;
      this.categoryIds = data.categoryIds;
      this.selectedOrganisationId = data.selectedOrganisationId;
      this.selectedEventId = data.selectedEventId;
      this.id = data.id;
      this.key = data.key;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {uuid}
  */
  eventIdentifier?: string;
  /**
  */
  categoryIds?: number[];
  /**
  * @type {int64}
  */
  selectedOrganisationId?: number;
  /**
  * @type {int64}
  */
  selectedEventId?: number;
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  key?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetCompanyProfessionRequestDTO>): GetCompanyProfessionRequestModel;
  static toModel(dto: DeepPartial<GetCompanyProfessionRequestDTO> | undefined | null): GetCompanyProfessionRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCompanyProfessionRequestDTO> | undefined | null): GetCompanyProfessionRequestModel | undefined {
    return dto ? new GetCompanyProfessionRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCompanyProfessionRequestModel> | GetCompanyProfessionRequestModel): GetCompanyProfessionRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      eventIdentifier: unwrapped.eventIdentifier,
      categoryIds: unwrapped.categoryIds,
      selectedOrganisationId: unwrapped.selectedOrganisationId,
      selectedEventId: unwrapped.selectedEventId,
      id: unwrapped.id,
      key: unwrapped.key,
      searchCriteria: unwrapped.searchCriteria,
    } as GetCompanyProfessionRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetCompanyProfessionRequestModel, can not map to GetCompanyProfessionRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
